import React, { useState, useContext, useEffect } from "react"
import styled from "styled-components"
import { FaCalendar } from "@react-icons/all-files/fa/FaCalendar"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import Loader1 from "../../interceptors/loader-interceptor"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { findCurrentJourneyCode, getAge, getKeyFromValueLookup, DataLayerIntegration } from "../services/helperFunctions"
import { fetchApplicationDetails, sendEmailBI, saveApplication, downloadPaymentReceipt } from "../../services/apiservice" 
import { ErrorContext } from "../context/errorContext";
import {errorToastr,successToastr,clearToastr} from "../../services/error-handler"
import * as moment from "moment";
import { withPrefix } from "gatsby"
import * as lookup from "../../../static/lookup.json";
import { MD5 } from "crypto-js"
import axios from "axios"
import { maskAlternateCharsInEmail } from "../../shared/functions"
import * as channelJson from "../../../static/channel.json"

export default function SuccessfulTransactions(props) {
  const[errorState, setErrorState] = useContext(ErrorContext);
  const [b64Receipt, setB64Receipt] = useState();
  const [needToDoEnach, setNeedToDoEach] = useState(false)
  console.log(errorState)
  const [localJourneyData, setLocalJourneyData] = useState({})
  useEffect(async()=>{
    let payload = {
      _id: journeyState.journeyId,
    }
    fetchApplicationDetails(payload).then(res=>{
      console.log(res);
      let transactionDetails = res?.journeyData?.transactionDetails
      if(transactionDetails && transactionDetails.transactions?.length){
        let lastTransaction = transactionDetails.transactions[transactionDetails.transactions.length -1]
        if(lastTransaction && lastTransaction.mandateOpt){
          if(lastTransaction.hasOwnProperty("mandate")){
            if(lastTransaction.mandate?.status !== "active"){
              setNeedToDoEach(true)
            }
          }else{
            setNeedToDoEach(true)
          }
        }
      }
      
      setLocalJourneyData(res);
      callDataLayer(res)
      getDownloadPaymentReceiptData();
    })
    .catch(err=>{
      console.error(err)
    })
  },[])

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const date = new Date();
  const validPayDate = new Date(date.setDate(date.getDate() + 30)).toLocaleDateString();

  const callDataLayer = (allJourneyDataResponse) => {
    const dateofbirth = allJourneyDataResponse?.journeyData?.lifeAssuredDetails?.dob;
    const formatedDob = moment.unix(dateofbirth).format('MM/YYYY');
    const AGE = getAge(dateofbirth);
    const emailID = allJourneyDataResponse?.journeyData?.basicDetails?.emailID;
    const mobileNo = allJourneyDataResponse?.journeyData?.basicDetails?.mobileNo;
    let encryptedEmail 
    let encryptedMobileNo
    try {
      encryptedEmail = MD5(emailID)?.toString();
      console.log(encryptedEmail, "encryptedEmail")
      encryptedMobileNo = MD5(mobileNo)?.toString();
      console.log(encryptedMobileNo, "encryptedMobileNo")
    }catch(err){
      console.log(err, "dsds")
    }
    
    const transactions = allJourneyDataResponse?.journeyData?.transactionDetails?.transactions
    const applicationNoGenerationTime = allJourneyDataResponse?.journeyData?.basicDetails?.applicationNoGenerationTime
    const policyTerm = Number(allJourneyDataResponse?.journeyData?.productDetails?.policyTerm)
    const policyTermInSeconds = 31556926 * policyTerm
    const policyStartDateCalc = moment.unix(applicationNoGenerationTime)?.format("DD-MM-YYYY")
    const policyEndDateCalc = moment.unix(applicationNoGenerationTime + policyTermInSeconds)?.format("DD-MM-YYYY")
    const riders = allJourneyDataResponse?.journeyData?.productDetails?.riders?.rider
    let addOnsCalc
    if(riders.length){
      let riderNames = riders?.map(eachRider => eachRider.name)
      addOnsCalc = riderNames.join("_")
    }else{
      addOnsCalc = ""
    }
    
    var PaymentMode = transactions?.[transactions.length -1]?.paymentMethod;         //Credit Card/Debit Card/Internet Banking/UPI
    var PolicyType = allJourneyDataResponse?.journeyData?.productDetails?.productType;
    var PolicyStartDate =  policyStartDateCalc;
    var PolicyEndDate = policyEndDateCalc;
    var PolicyNo = allJourneyDataResponse?.journeyData?.basicDetails?.applicationNumber;
    var SumInsured = allJourneyDataResponse?.journeyData?.productDetails?.sumAssured;
    var QuoteNo = allJourneyDataResponse?.journeyData?.basicDetails?.illustrationNumber;              //Quotation Number
    var Age = AGE;
    var Gender = lookup.gender[0][allJourneyDataResponse?.journeyData?.lifeAssuredDetails?.gender];
    var PaymentFrequency = allJourneyDataResponse?.journeyData?.paymentFrequency;
    var PremiumAmount = allJourneyDataResponse?.journeyData?.premium;
    var AdditionalBenefit = addOnsCalc;
    var ID1 = encryptedMobileNo;                //Encrypted Mobile Number of the user
    var ID2 = encryptedEmail;                 //Encrypted Email ID of the user
    var DOB = formatedDob;                 //MM/YYYY momentfucntion
    var TobaccoConsumer = allJourneyDataResponse?.journeyData?.lifeAssuredDetails?.personalDetails?.smoking === "N" ? "No" :  "Yes"   //Yes/No
    var ApplicationNumber = allJourneyDataResponse?.journeyData?.basicDetails?.applicationNumber;
    var Addons = addOnsCalc;
    var PaymentOption = allJourneyDataResponse?.journeyData?.paymentStep === "N" ? "paynow" : "paylater";
    var ProductCode = '90073';
    var ProductCategory = 'Term';
    var ProductSubCategory = 'Protection';
    var State = lookup.state[0][allJourneyDataResponse?.journeyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state];       //State where purchase is made
    var products = [];
    // products.push({
    //   'id': '90073',                               //Product Code
    //   'name': 'iSelect Smart360 Term Plan',   //name of the Product
    //   'category': 'Term',                     //Category of the Product
    //   'price': allJourneyDataResponse?.journeyData?.premium,                  //Product Price
    //   'quantity': '1'                         //Number of Products Purchased
    // })
    products.push({
      'name': 'iSelect Smart360 Term Plan',     // Name or ID is required.
      'id': '90073',
      'price': Number(allJourneyDataResponse?.journeyData?.premium),
      'brand': 'CanaraHSBC',
      'category': 'Term',
      'quantity': 1,                           // Optional fields may be omitted or set to empty string.
    })

    var items = [];
    items.push({
      item_id: "90073", //HSN Code/ITEM Code
      item_name: "iSelect Smart360 Term Plan",
      currency: "INR",
      item_brand: "CanaraHSBC",
      item_category: "Term", //Product Category
      item_category2: "Protection", //Product SubCategory
      price: Number(allJourneyDataResponse?.journeyData?.premium), //individual product price
      quantity: 1
    })
    window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   'event': 'PurchaseConfirm',
    //   'ecommerce': {
    //     'currencyCode': 'INR',
    //     'purchase': {
    //       'actionField': {
    //         'id': transactions?.[transactions.length -1]?.paymentTxnId,               //Transaction ID (String)
    //         'affiliation': 'CanaraHSBCWeb',      //Affiliation or Store Name
    //         'revenue': allJourneyDataResponse?.journeyData?.premium,                 //Total Revenue (inclusive of tax., shipping, etc.) (number) - Premium
    //         'tax': allJourneyDataResponse?.journeyData?.productDetails?.premServiceTax
    //       },
    //       'products': products
    //     }
    //   }
    // });
    window.dataLayer.push({
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': transactions?.[transactions.length -1]?.paymentTxnId,                         // Transaction ID. Required for purchases and refunds.
            'affiliation': 'Online Journey',
            'revenue': allJourneyDataResponse?.journeyData?.premium,                     // Total transaction value (incl. tax and shipping)
            'tax':allJourneyDataResponse?.journeyData?.productDetails?.premServiceTax,
            'shipping': '',
            'coupon': ''
          },
          'products': products
        }
      }
    })

    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
          transaction_id: transactions?.[transactions.length -1]?.paymentTxnId, // Unique transaction id of every purchase
          affiliation: "Online Journey",
          value: Number(allJourneyDataResponse?.journeyData?.premium), // total booking amaount
          tax: allJourneyDataResponse?.journeyData?.productDetails?.premServiceTax, // tax on booking
          currency: "INR",
          coupon: "", //Coupon/Promo Code
          discount: 0,
          payment_type: transactions?.[transactions.length -1]?.paymentMethod,
          items: items
      }
    })
  }
  useEffect(async () => {
    if (journeyState.applicationNo && (journeyState.channel == "website" || journeyState.channel=="WEBSITE")) {
      var appno = journeyState.applicationNo;
      var cid = 9;
      var pid = 7;
      var m3_u = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//www.invincibleiq.com/details/bck';
      let array = new Uint32Array(1);
      crypto.getRandomValues(array);
      var m3_r = Math.floor(array[0] % 99999999999);
      var sNew = document.createElement('script');
      var m3_url = m3_u + '/cid:' + cid + '/pid:' + pid + '/aid:3' + '/cb:' + m3_r + '/appno:' + appno + (document.characterSet ? '/charset:' + document.characterSet : '');
      sNew.src = m3_url;
      var s0 = document.getElementsByTagName('script')[0];
      s0.parentNode.insertBefore(sNew, s0);
      // console.info("inside11",appno,m3_u,m3_url);
      // console.info("inside",sNew, s0.parentNode.insertBefore(sNew, s0));
    }
  }, [journeyState.applicationNo])

  const handleClick = () => {
    let eventName = ""
    let formControlKey = "completeApplication"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, eventName, props.sections?.[props.currentSectionIndex]?.sectionId,formControlKey, journeyState)
    // getAllJourneyData(eventName, formControlKey)
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: needToDoEnach ? props.currentPageIndex : props.currentPageIndex + 1,
        lastSection: needToDoEnach ? props.currentSectionIndex + 1  : 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      }
    }
    saveApplication(sendPayload).then(res => {
      console.log(journeyState, "from successfull transcation")
      if (needToDoEnach) {
        setErrorState({})
        props.setCurrentSectionIndex(prev => prev +1) // this moves to first section of next page
        let transactions = localJourneyData?.journeyData?.transactionDetails?.transactions
        setJourneyState((prev) => {
          return ({
            ...prev,
            paymentMode: transactions?.[transactions.length -1]?.paymentMethod,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
          })
        })
      } else {
        console.log(sectionState)
        setSectionState(prev => {
          // making section data empty to load new sectionData
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })
        props.setCurrentPageIndex(prev => prev + 1)
        setErrorState({})
        props.setCurrentSectionIndex(0) // this moves to first section of next page
        setErrorState(prev=>{
          return {
            ...prev,
            ['TaxIdentificationNumber']:""
          }
        })
        let transactions = localJourneyData?.journeyData?.transactionDetails?.transactions
        setJourneyState((prev) => {
          return ({
            ...prev,
            paymentMode: transactions?.[transactions.length -1]?.paymentMethod,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
          })
        })
      }
    }).catch(err => {
      console.log(err, "err in saveApplication")
    })
  }

  const getDownloadPaymentReceiptData = async ()=>{
    const paymentTxnId = journeyState?.paymentDecryptData?.paymentTxnId ||"qwertyui234567";
    const res = await downloadPaymentReceipt(journeyState.journeyId,paymentTxnId);
    if(res.status){
      setB64Receipt(res.data)
    }else{
      errorToastr("Payment data does not exist!")
    }
  }

  const getDownloadPaymentReceiptData2 = async ()=>{
    const paymentTxnId = journeyState?.paymentDecryptData?.paymentTxnId || "qwerty1234567";
    const res = await downloadPaymentReceipt(journeyState.journeyId,paymentTxnId);
    if(res.status){
      setB64Receipt(res.data);
      pdfDownload(res.data);
    }else{
      errorToastr("Payment data does not exist!")
    }
  }

  const downloadReceipt = () =>{
    if(b64Receipt){
      pdfDownload(b64Receipt);
    }else{
      getDownloadPaymentReceiptData2();
    }
    let eventName = ""
    let formControlKey = "downloadReceipt"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, eventName, props.sections?.[props.currentSectionIndex]?.sectionId,formControlKey, journeyState)
  }

// const getAllJourneyData = async (e,formControlKey) =>{
//     let apiUrl = process.env.GATASBY_API_URL
//     try{
//       let alljounreyData = await axios.get(`${apiUrl}/all-jounrey-data-internal/${journeyState.journeyId}`)
//       DataLayerIntegration(alljounreyData, e, props.sections?.[props.currentSectionIndex]?.sectionId,formControlKey)
//     }
//     catch(err){
//       console.log("err in section change",err)
//     }
//  }

  const pdfDownload = (b64Receipt)=>{
      const downloadLink = document.createElement("a")
      downloadLink.href = `data:application/pdf;base64,${b64Receipt}`
      const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_Receipt_${journeyState.applicationNo}.pdf`;
      downloadLink.download = fileName;
      downloadLink.click();
  }
  let emailId = localJourneyData?.journeyData?.basicDetails?.emailID
  let maskedEmail = maskAlternateCharsInEmail(emailId)

  return (
    <>
    <Loader1/>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
              `}
      </style>

      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="iselect-box-design">
              <div className="iselect-padding">
                <div className="payment-receipt-structure-design">
                  <div className="payment-receipt-structure-design-healine">
                    {" "}
                    {/* <img src={withPrefix("/images/success-icon.png")} />
                    <h2>Congratulations!</h2>
                    <h3>We have received your payment</h3>
                    <div className="line"></div> */}
                    <p>
                      Please complete your entire application before {moment(localJourneyData?.journeyData?.loginDate).add(45, 'days').format("DD-MMM-YYYY")} as your premium will be marginally increased
                      after this date.
                    </p>
                  </div>
                  <div className="download-receipt-structure">
                    <div className="ap-receipt-stucture">
                      {" "}
                      <span>Application Number</span>
                      <h2>{journeyState.applicationNo}</h2>
                    </div>
                    {/* <a style={{color:"#fff", textDecoration:"none",}}>
                      <div className="download-ap-receipt-stucture">
                        {" "}
                        <img src={withPrefix("/images/download-receipt.png")} style={{cursor:"pointer"}} aria-hidden="true" onClick={downloadReceipt}/>
                        <p aria-hidden="true" onClick={downloadReceipt} style={{cursor:"pointer"}}>
                          Click to
                          <br />
                          Download Receipt
                        </p>
                      </div>
                    </a>{" "} */}
                  </div>
                  <div className="clearfix"></div>
                  <div className="emil-structure">
                    {/* <p>
                      Payment Receipt has also been sent to your registered
                      email ID <strong>{maskedEmail}</strong>
                    </p> */}
                    <p>
                      You are only a few minutes away from completing your
                      application. Please click on Proceed to continue with your application.
                    </p>
                  </div>
                </div>

                <div className="iselect-mg-bottom hidden-desktop-screen">
                  <div className="col-md-12">
                    <div className="but-center text-center">
                      <div className="previous-btn cen"  style={{padding:"0px"}}>
                        <a style={{padding:"0px"}}>
                          {" "}
                          <button
                            type="submit"
                            value="button2"
                            name="button2"
                            style={{backgroundColor:"transparent", padding:"14px 40px", border:"none", borderRadius:"10px", color:"#fff"}}
                            onClick={handleClick}
                          >
                            {needToDoEnach ? "Proceed" : "Complete Application"}
                          </button>{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="previous-btn cen" style={{width:"auto",padding:"0"}}>
                <a aria-hidden="true" onClick={handleClick}>
                  {" "}
                  <button
                    type="submit"
                    value="button2"
                    name="button2"
                    style={{backgroundColor:"transparent", padding:"0px 10px", border:"none", color:"#fff",width:"initial",margin:"0"}}
                  >
                    {needToDoEnach ? "Proceed" : "Complete Application"}
                  </button>{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
